import { START_WEEK, WORK_TYPE } from './constants';
import type { IResolvedOption } from './interfaces/IOption';

export const DEFAULT_OPTIONS: IResolvedOption = {
  lang: 'ru',
  fallbackLang: 'ru',
  startWeek: START_WEEK.MONDAY,
  workType: WORK_TYPE.SINGLE,
  translations: {},
  onInput: undefined,
  onChange: undefined,
  displayFormat: undefined,
  valueFormat: undefined,
  displayFormatsByLang: {
    ru: 'dd.MM.yyyy',
    en: 'MM/dd/yyyy',
  },
  manualInput: true,
  commitOnSelect: true,
  shouldCloseOnSelect: undefined,
  mode: undefined,
  rangeSeparator: ' - ',
  rangeEndSelector: undefined,
  timezone: 'local', // По умолчанию используем локальный часовой пояс
  onOpen: undefined,
  onClose: undefined,
  onSelect: undefined,
  onMonthChange: undefined,
  onYearChange: undefined,
  onTimeChange: undefined,
  onViewChange: undefined,
  onDestroy: undefined,
  disabledDates: [],
  isDateDisabled: undefined,
  minDate: null,
  maxDate: null,
  openToDate: null,
};
